import StripePaymentElement from '@/app/components/payment/components/method/components/stripe-payment-element';
import ZipCodeInputV2 from '@/app/components/payment/components/method/components/zip-code-input-v2';
import { Flex } from '@chakra-ui/react';
import { Box, Text } from '@cmpsr/components';
import { UseFormReturn } from 'react-hook-form';
import { PaymentFormState } from '../PPRAPaymentPage';
import SecurePayments from './SecurePayments';

interface PaymentSectionProps {
  setIsPaymentComplete: (value: boolean) => void;
  showPaymentError: boolean;
  setShowPaymentError: (value: boolean) => void;
  form: UseFormReturn<PaymentFormState>;
  getPrice: () => void;
  paymentSectionRef: React.RefObject<HTMLDivElement>;
}

const PaymentSection = ({
  setIsPaymentComplete,
  showPaymentError,
  setShowPaymentError,
  paymentSectionRef,
  form,
  getPrice,
}: PaymentSectionProps) => {
  return (
    <Box
      ref={paymentSectionRef}
      width="100%"
      backgroundColor="transparent"
      display="flex"
      flexDirection="column"
      gap="25px"
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Text variant="text-header-XS" textTransform="uppercase">
          Payment
        </Text>
        <SecurePayments />
      </Box>

      <Flex borderRadius="10px" p={4} flexDirection="column" backgroundColor="white">
        <StripePaymentElement
          onChange={(event) => {
            setIsPaymentComplete(event.complete);
            if (event.complete) setShowPaymentError(false);
          }}
        />
        {showPaymentError && (
          <Text color="salmon-light" fontSize="xs" mt="-15px" pb="15px" zIndex="2">
            Please check your payment information and try again.
          </Text>
        )}

        <ZipCodeInputV2 form={form} getPrice={getPrice} />
      </Flex>
    </Box>
  );
};

export default PaymentSection;
